<template>
  <ion-page>
    <!-- cabecera con buscador integrada (estilo InventarioDetalle/MainInventarios) -->
    <CabeceraComponentBackSearch
      :pdv="pdv"
      :isIOS="isIOS"
      :titulo="`${ubi} (${clasif})`"
      color="primary"
      :showBack="false"
      v-model="filtro_busqueda"
      :debounceMs="debounceMs"
      :placeholder="'Material'"
      @search-start="onSearchStart"
      @search-change="filtroInputSearch"
    />

    <ion-content>
      <!-- Indicador de búsqueda mientras se aplica el filtro -->
      <ion-row class="ion-justify-content-center" v-if="isSearching">
        <ion-col size="48" class="ion-align-self-center">
          <ion-progress-bar type="indeterminate" color="primary"></ion-progress-bar>
        </ion-col>
      </ion-row>
      
      <!-- FAB escáner (indicador) -->
      <ion-fab vertical="top" horizontal="end" slot="fixed">
        <ion-fab-button :key="`scan-activo:${blinker}`" :class="blinker ? 'activo' : 'inactivo'" @click="abrirModalEscaner">
          <i class="fas fa-solid fa-barcode-read muy-grande" :class="blinker ? 'blink' : 'not-blink'" :key="`ion-scan:${blinker}`"></i>
        </ion-fab-button>
      </ion-fab>

      <!-- FAB Añadir Artículo (bottom-end) - Reemplaza al botón anterior -->
      <ion-fab vertical="bottom" horizontal="end" slot="fixed" v-if="showme">
        <ion-fab-button @click="agregarArticulo" :disabled="!ubicacionEditable"> <!--  || ubicacionBobLlena -->
          <!-- Icono compuesto: caja + símbolo de añadir -->
          <span class="icon-stack">
            <i class="fas fa-box base-icon"></i>
            <i class="fas fa-plus overlay-icon"></i>
          </span>
        </ion-fab-button>
      </ion-fab>
      
      <!-- Spinner inicial mientras bloqueamos y cargamos líneas -->
      <ion-row class="spin ion-justify-content-center" v-if="!showme">
        <ion-col class="spin ion-align-self-center" size="48">
          <ion-spinner></ion-spinner>
        </ion-col>
      </ion-row>

      <div class="container-tablet">

        <!-- Contador sticky al estilo InventarioDetalle -->
        <div v-if="filtradas && filtradas.length > 0" class="pickings-counter-sticky">
          <ion-button expand="block" fill="outline" size="large" class="trigger_scan">
            <ion-title>
              <ion-text class="ion-text-wrap estrecho">
                <b>{{ filtradas.length }} Materiales</b>
              </ion-text>
            </ion-title>
          </ion-button>
        </div>

        <!-- Lista de líneas editable con búsqueda y scroll incremental -->
        <ion-list v-if="visibleItems && visibleItems.length" style="margin: 0; padding-left: 10px;">
          <!-- cada línea editable con input de contada (stoman) y métricas -->
          <div v-for="(ln, idx) in visibleItems" :key="ln.id || `${ln.sku}-${ln.lote || 'N'}`">
            <ion-item class="ion-no-padding ion-no-margin">
              <ion-row :key="idx" class="linea-ubi">
                <ion-col size="22" class="ion-no-margin ion-no-padding ion-align-self-center ion-text-left">
                  <p class="titulo">{{ ln.sku }}</p>
                  <div class="desc">{{ ln.nombre || ln.descripcion || '' }}</div>
                  <div class="badges-container">
                    <ion-badge mode="md" color="tertiary" v-if="ln.lote && ln.lote !== 'N'">Lote: {{ ln.lote }}</ion-badge>
                    <ion-badge mode="md" color="danger" v-if="ln.is_primaria === 1 && ln.hasSecundarias === 1">* Tiene secundarias</ion-badge>
                    <ion-badge mode="md" color="warning" v-if="ln.is_primaria === 0">Es secundaria</ion-badge>
                  </div>
                  <div v-if="ln.usr && ln.estado !== 'P' && ln.estado !== 'R'" class="usuario-contado">Contado por: <b>{{ ln.usrName || ln.usr }}</b></div>
                </ion-col>
                <ion-col size="12" class="ion-align-self-center ion-justify-content-center ion-text-center">
                  <div class="ion-text-center mini-label">Stock actual</div>
                  <div class="valor-texto">{{ ln.stock }}</div>
                  <hr style="border: 0.1px solid var(--ion-color-medium); margin: 6px 0;"/>
                  <div class="ion-text-center mini-label">Stock nuevo</div>
                  <div class="stock-nuevo">{{ ln.stonue || 0 }}</div>
                </ion-col>
                <ion-col size="14" class="ion-align-self-center ion-text-end">
                  <div class="ion-text-center mini-label">Contada</div>
                  <ion-input class="ion-text-center stoman-input bordered" type="number" :value="ln.inputCantidad" :min="0" :max="ln.geslot === 'E' ? 1 : 9999" :disabled="inputDeshabilitado(ln)" @ionFocus="pausarEscaner" @ionBlur="reanudarEscaner" @ionChange="v => actualizarContada(ln, v)" @keyup.enter="$event.target.blur()"></ion-input>
                  <small class="valor-ud">Precio U: {{ ln.preuni }}</small>
                  <small class="dif" :class="getDifColor(ln)">Dif: {{ calcularDiferencia(ln) }}</small>
                </ion-col>
              </ion-row>
            </ion-item>
          </div>

          <!-- Carga incremental -->
          <ion-infinite-scroll threshold="100px" @ionInfinite="onIonInfinite" :disabled="!puedeCargarMas">
            <ion-infinite-scroll-content loading-spinner="bubbles" loading-text="Cargando más materiales..."></ion-infinite-scroll-content>
          </ion-infinite-scroll>
        </ion-list>

      </div>
    </ion-content>

    <!-- Footer reutilizable: SALIR / CONFIRMAR o REABRIR -->
    <FooterDualActions
      v-if="showme"
      left-text="Salir"
      :right-text="textoBotonDerecho"
      left-color="danger"
      :right-color="colorBotonDerecho"
      left-fill="solid"
      right-fill="solid"
      left-size="normal"
      right-size="normal"
      :right-disabled="disabledBotonDerecho"
      @left-click="salir"
      @right-click="clickBotonDerecho"
    />
  </ion-page>
</template>

<script>
import { defineComponent } from 'vue'
import CabeceraComponentBackSearch from '@/components/CabeceraComponentBackSearch.vue'
import FooterDualActions from '@/components/FooterDualActions.vue'
import eventBus from '@/event-bus'
import { openToast } from '@/utilities/services/alert-utilities'
import { modalController } from '@ionic/vue'
import AppScanModal from '@/components/scanner/AppScanModal.vue'
import InventarioSeleccionProductoModal from '@/components/search/inventario-seleccion-producto-modal.vue'
import { openAlertaV2, openAlertaBinaria } from '@/utilities/services/alert-utilities'
import { inventario_estados, esArticulo, esEan } from '@/utilities/global-constants'
import { scanGenericStart, scanGenericStop } from '@/utilities/scanner/scan-generic'
import { stockPdvFiltrado } from '@/utilities/scanner/scan-sku'

export default defineComponent({
  name: 'InventarioUbicacionPage',
  components: { CabeceraComponentBackSearch, FooterDualActions },
  props: ['pdv', 'fecinv', 'ubi', 'clasif'],
  data () {
    return {
      isIOS: this.$route.meta.isIOS,
      ubiku_rol: this.$route.meta.ubiku_rol,
      email: this.$route.meta.email,
      showme: false,
      lineas: [],
      filtro_busqueda: '',
      searchSpec: null,
      filtradas: [],
      visibleItems: [],
      batchSize: 30,
      blinker: false,
      // identificador para el canal de eventos del escáner genérico de PDA
      element_id: 'inventario-ubicacion-scan',
      liberado: false,
      inventario_estados,
      isSearching: false,
      isEditing: false,
      debounceMs: 500,
      sse: null
    }
  },
  async mounted () {
    this.$NoBackNavigator()
    eventBus().emitter.once('transicion', () => (this.showme = false))
    const yaBloqueada = await this.estaBloqueada()
    if (yaBloqueada) {
      openToast('Ubicación bloqueada, acceso denegado')
      this.$router.replace({ name: 'inventario_detalle', params: { pdv: this.pdv, fecinv: this.fecinv, clasif: this.clasif } })
      return
    }
    const puedeEntrar = await this.bloquearUbicacion()
    if (!puedeEntrar) {
      openToast('Ubicación bloqueada, acceso denegado')
      this.$router.replace({ name: 'inventario_detalle', params: { pdv: this.pdv, fecinv: this.fecinv, clasif: this.clasif } })
      return
    }
    await this.cargarLineas()
    this.aplicarFiltros(true)
    this.showme = true
    // activamos el escáner genérico para lecturas de PDA que alimenten el buscador
    await this.escaner_generico()
    this.blinker = true
    try {
      const base = this.$http?.defaults?.baseURL || ''
      const provider = (this.$route?.meta?.provider) || 'google'
      const key = this.$http?.defaults?.headers?.['key']
      const qs = `?dev=${encodeURIComponent(this.$deviceUuid)}&ml=${encodeURIComponent(this.$current_user||'')}&wn=${encodeURIComponent(this.$wnumber||'')}&provider=${encodeURIComponent(provider)}&key=${encodeURIComponent(key||'')}`
      const url = `${base}/inventario_stream/${this.pdv}/${this.fecinv}/${encodeURIComponent(this.clasif)}/${encodeURIComponent(this.ubi)}${qs}`
      this.sse = new EventSource(url)
      this.sse.addEventListener('unlock', (ev) => {
        window.fake_console('unlock', ev)
        try {
          const d = JSON.parse(ev.data||'{}')
          if (String(d?.ubicacion||'') === String(this.ubi)) { this.salir() }
        } catch { void 0 }
      })
    } catch { void 0 }
  },
  async unmounted () {
    // detenemos el escáner genérico al salir de la página
    await scanGenericStop(this.element_id)
    try { if (this.sse) { this.sse.close(); this.sse = null } } catch { void 0 }
  },
  methods: {
    // Métodos para control de foco en inputs y pausa del escáner
    async pausarEscaner () {
      window.fake_console('Pausando escáner...')
      this.isEditing = true
      try {
        await scanGenericStop(this.element_id)
      } catch (e) { window.fake_console(e) }
    },
    async reanudarEscaner () {
      window.fake_console('Reanudando escáner...')
      this.isEditing = false
      try {
        await this.escaner_generico()
      } catch (e) { window.fake_console(e) }
    },
    async estaBloqueada () {
      if (!this.pdv || !this.fecinv || !this.ubi) return false
      try {
        const res = await this.$http.get(`/inventario_ubicacion/${this.pdv}/${this.fecinv}/${this.clasif}/${this.ubi}`)
        const data = Array.isArray(res.data) ? res.data : []
        return data.some(it => {
          const v = it?.blqUsr ?? it?.blqusr ?? it?.blqusu ?? it?.BLQUSU ?? it?.blqUSU
          return v !== null && v !== undefined && String(v).trim() !== ''
        })
      } catch (ex) {
        return false
      }
    },
    async bloquearUbicacion () {
      if (!this.pdv || !this.fecinv || !this.ubi) return false
      try {
        const res = await this.$http.post(`/inventario_ubicacion/${this.pdv}/${this.fecinv}/${this.clasif}/${this.ubi}`, { blqUsr: this.$current_user || this.$route.meta?.usr || this.$route.meta?.email || 'usuario', blqUsrName: this.$current_user_name || this.$route.meta?.uname || null, ubiku_rol: this.ubiku_rol, clasif: this.clasif })
        const body = res && res.data
        const esConflicto = !!(body && typeof body === 'object' && body.error === 'conflict')
        return !esConflicto
      } catch (ex) {
        return false
      }
    },
    async cargarLineas () {
      if (!this.pdv || !this.fecinv || !this.ubi) return
      try {
        // recuperamos las líneas de la ubicación
        const res = await this.$http.get(`/inventario_ubicacion/${this.pdv}/${this.fecinv}/${this.clasif}/${this.ubi}`)
        const data = Array.isArray(res.data) ? res.data : []
        // normalizamos las líneas para edición de stoman; dejamos otros campos tal como vienen
        this.lineas = data.map(it => ({
          id: it.id,
          sku: it.sku,
          nombre: it.nombre || it.descripcion,
          lote: it.lote ?? it.numlot,
          stock: it.stock ?? it.stoalm,
          stoman: it.stoman ?? 0,
          stonue: it.stonue ?? 0,
          inputCantidad: it.stoman ?? 0,
          preuni: it.preuni ?? 0,
          hasSecundarias: it.hasSecundarias,
          is_primaria: it.is_primaria ?? 0,
          estado: it.estado || inventario_estados.pendientes.db,
          geslot: it.geslot,
          usr: it.usr || null,
          usrName: it.usrName || null
        }))
        this.aplicarFiltros(true)
      } catch (ex) {
        openToast('Error cargando líneas de la ubicación')
        console.log(ex)
      }
    },
    // manejador del cambio en el buscador de la cabecera
    filtroInputSearch (q) {
      if (q && typeof q === 'object' && q.apply) {
        this.searchSpec = q
        this.filtro_busqueda = String(q.raw || '').trim()
      } else {
        this.searchSpec = null
        this.filtro_busqueda = String(q || '').trim()
      }
      this.aplicarFiltros(true)
    },
    onSearchStart () { this.isSearching = true },
    aplicarFiltros (reiniciar = false) {
      const spec = this.searchSpec
      const textoItem = (it) => {
        const nombre = it.nombre || ''
        const lote = `Lote: ${it.lote || 'N'}`
        const stock = `${it.stock ?? 0}`
        const contada = `${it.inputCantidad ?? it.stoman ?? 0}`
        const dif = `Dif: ${Number(it.inputCantidad ?? it.stoman ?? 0) - Number(stock)}`
        return `${it.sku} ${nombre} ${lote} ${stock} ${contada} ${dif}`
      }
      const porTexto = (it) => {
        if (!spec || spec.isEmpty) return true
        const toks = Array.isArray(spec.tokens) && spec.tokens.length > 0 ? spec.tokens : [spec.norm || '']
        const esc = toks.map(t => String(t).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
        const re = new RegExp(esc.join('.*'), 'i')
        return re.test(textoItem(it))
      }
      this.filtradas = (this.lineas || []).filter(porTexto)
      if (reiniciar) {
        const inicial = Math.min(this.batchSize, this.filtradas.length)
        this.visibleItems = this.filtradas.slice(0, inicial)
      } else {
        const limite = Math.min(this.visibleItems.length, this.filtradas.length)
        this.visibleItems = this.filtradas.slice(0, limite)
      }
      this.isSearching = false
    },
    // evento de InfiniteScroll para añadir más elementos visibles por lotes
    async onIonInfinite (ev) {
      try {
        const current = this.visibleItems.length
        const siguiente = Math.min(current + this.batchSize, this.filtradas.length)
        if (siguiente <= current) {
          ev.target.disabled = true
        } else {
          this.visibleItems = this.filtradas.slice(0, siguiente)
        }
      } finally {
        ev.target.complete()
      }
    },
    actualizarContada (ln, v) {
      const raw = v?.detail?.value ?? v
      if (raw === '' || raw === null || raw === undefined) { ln.inputCantidad = null; return }
      let val = Number(raw)
      if (isNaN(val)) { ln.inputCantidad = null; return }
      
      ln.inputCantidad = val
    },
    // checkReglasBobina () {
    //   if (!this.ubi || !this.ubi.startsWith('BOB')) return null
    //   const ls = this.lineas || []
    //   const activos = ls.filter(l => Number(l.inputCantidad || 0) > 0)
    //   
    //   // Regla: No se permiten productos con geslot='N' en ubicaciones BOB
    //   const invalidos = activos.filter(l => l.geslot === 'N')
    //   if (invalidos.length > 0) return 'No se permiten productos estándar en ubicaciones BOB.'
    //   
    //   const bobinas = activos.filter(l => l.geslot === 'E')
    //   const cables = activos.filter(l => l.geslot === 'S')
    //   
    //   // Solo 1 bobina activa permitida
    //   if (bobinas.length > 1) return 'Solo se permite 1 Bobina activa.'
    //   // Solo 1 cable activo permitido
    //   if (cables.length > 1) return 'Solo se permite 1 Cable activo.'
    //   
    //   // Regla: Si hay cable activo, debe haber bobina activa obligatoriamente
    //   if (cables.length > 0 && bobinas.length === 0) return 'Si hay cable activo, debe haber una bobina activa.'

    //   // Si hay ambos, lotes deben coincidir
    //   if (bobinas.length === 1 && cables.length === 1) {
    //     const lB = String(bobinas[0].lote || '').trim()
    //     const lC = String(cables[0].lote || '').trim()
    //     if (lB !== lC) return `El lote del cable (${lC}) no coincide con la bobina (${lB}).`
    //   }
    //   
    //   return null
    // },
    mostrarSecundarias (ln) {
      console.log(ln.hasSecundarias)
      const v = ln?.hasSecundarias
      if (!v) return false
      const arr = Array.isArray(v) ? v : (() => { try { return JSON.parse(v) } catch { return [] } })()
      return Array.isArray(arr) && arr.length > 0
    },
    async abrirModalEscaner () {
      // modal de escaneo EAN-13 reutilizable
      try {
        this.blinker = false
        const modal = await modalController.create({
          component: AppScanModal,
          componentProps: { titulo: 'Escanea un código', elementId: 'inventario-ubicacion-scan' }
        })
        await modal.present()
        const { data, role } = await modal.onWillDismiss()
        this.blinker = true
        if (role === 'confirm' && typeof data === 'string') {
          await this.procesarLectura(data)
        }
      } catch (ex) {
        this.blinker = true
        openToast('No se pudo abrir el escáner')
        console.log(ex)
      }
    },
    async procesarLectura (codigo) {
      if (!codigo) return
      const input = String(codigo || '').replace(/\?/g, '_')
      // Soportamos tanto lecturas de SKU como de EAN
      if (esArticulo.test(input) || esEan.test(input)) {
        // Buscamos candidatos en el stock del PDV por coincidencia exacta (tags incluyen EAN y SKU)
        const candidatos = stockPdvFiltrado(input, 'exacta', 0) || []
        // Articulos sin catalogo (PDVs de Gestion 2000) no estan en el stock local pero si en las lineas de la ubicacion
        const enLineas = (this.lineas || []).some(l => String(l.sku || '').toLowerCase() === input.toLowerCase())
        if (candidatos.length === 0 && enLineas) {
          // nada que añadir, solo filtramos la lista
        } else if (candidatos.length === 0) {
          // Avisamos explícitamente si no encontramos nada en el PDV
          await openAlertaV2(
            'Producto inexistente en el PDV',
            `El código "${input}" no figura entre los artículos del PDV o no tiene stock.`
          )
          return
        } else {
          // Preferimos el que ya está en esta ubicación; si no, el primero
          const preferido = candidatos.find(c => String(c.ubi || '') === String(this.ubi)) || candidatos[0]
          const yaExiste = (this.lineas || []).some(l => String(l.sku || '') === String(preferido.sku || ''))
          // solo se ofrece el alta si la ubicación se puede editar (no contada ni cerrada)
          if (!yaExiste && this.ubicacionEditable) {
            const desc = preferido.shortDescription || preferido.nombre || ''
            const ubic = preferido.ubi || 'Sin ubicación'
            const sto = preferido.stoalm || 0
            const msg = `
                <div class="ion-text-left">
                  <p><strong>SKU:</strong> ${preferido.sku}</p>
                  <p><strong>Desc:</strong> ${desc}</p>
                  <p><strong>Stock actual:</strong> ${sto}</p>
                  <p><strong>Ubicación:</strong> ${ubic}</p>
                  <br/>
                  ¿Deseas añadir este artículo a la ubicación actual?
                </div>
              `
            const confirmar = await openAlertaBinaria(
              'Añadir artículo detectado',
              msg,
              'Cancelar',
              'Añadir'
            )
            if (confirmar) {
              await this.guardarNuevoArticulo(preferido)
            }
          }
        }
      }
      this.filtro_busqueda = input
      this.filtroInputSearch(input)
    },
    // listener de lecturas del escáner genérico de PDA: pone el texto en el buscador y aplica filtros
    async lectorEventosGenericos () {
      const self = this
      eventBus().emitter.off(`lectura_generica:${this.element_id}`)
      eventBus().emitter.once(`lectura_generica:${this.element_id}`, async (input_scaner_in) => {
        await self.procesarLectura(input_scaner_in)
        // nos re-suscribimos para siguientes lecturas sin requerir interacción
        self.lectorEventosGenericos()
      })
    },
    // activación del escáner genérico reutilizable: reinicia, activa y suscribe listener
    async escaner_generico () {
      await scanGenericStop(this.element_id)
      await scanGenericStart(this.element_id, 'inventario-ubicacion')
      await this.lectorEventosGenericos()
    },
    calcularDiferencia (ln) {
      const st = Number(ln.stock ?? 0)
      // Calculamos el total real proyectado: (Total BD - Contado en esta Ubi BD) + Contado en esta Ubi Input
      const stonue = Number(ln.stonue ?? 0)
      const stoman_bd = Number(ln.stoman ?? 0)
      const stoman_input = Number(ln.inputCantidad ?? ln.stoman ?? 0)
      
      const totalReal = (stonue - stoman_bd) + stoman_input
      
      return totalReal - st
    },
    getDifColor (ln) {
      // color por umbral de diferencia
      const dif = this.calcularDiferencia(ln)
      if (dif === 0) return 'primary'
      return dif > 0 ? 'warning' : 'darkdanger'
    },
    async guardarNuevoArticulo (item) {
      // validaciones mínimas del item seleccionado
      if (!item || !item.sku) { await openAlertaV2('Alta de artículo', 'No se pudo determinar el SKU del artículo seleccionado'); return }
      const stoalm = Number(item.stoalm ?? 0)
      if (isNaN(stoalm)) { await openAlertaV2('Alta de artículo', 'El stock del artículo (STOALM) no es un número válido'); return }
      
      const payload = {
        fecinv: this.fecinv,
        email: this.email,
        clasif: this.clasif,
        ubicacion: this.ubi,
        sku: item.sku,
        numlot: item.lote || 'N',
        stoman: null,
        stoalm,
        ubiku_rol: this.ubiku_rol
      }
      
      try {
        // Preservamos los inputs actuales antes de recargar
        const estadoLineas = {}
        if (this.lineas && this.lineas.length > 0) {
          this.lineas.forEach(l => {
            const k = l.id || `${l.sku}-${l.lote || 'N'}`
            estadoLineas[k] = l.inputCantidad
          })
        }

        const res = await this.$http.post(`/inventario_nuevo_articulo/${this.pdv}`, payload)
        // Validación de respuesta del backend (homogeneización de errores)
        const data = (res && res.data) || {}
        if (Object.keys(data).length === 0 || data.status === 0 || data.error) {
          throw { response: { data: { message: data.message || data.alert || 'Error al añadir artículo.' } } }
        }
        await this.cargarLineas()
        
        // Restauramos los inputs preservados
        if (this.lineas && this.lineas.length > 0) {
          this.lineas.forEach(l => {
            const k = l.id || `${l.sku}-${l.lote || 'N'}`
            if (estadoLineas[k] !== undefined) {
              l.inputCantidad = estadoLineas[k]
            }
          })
        }

        this.aplicarFiltros(true)
        openToast('Artículo añadido a la ubicación')
      } catch (exPost) {
        const msg = exPost.response?.data?.message || exPost.response?.data?.alert || 'No se pudo dar de alta la línea en inventario.'
        openToast(msg)
        console.error(exPost)
      }
    },
    async agregarArticulo () {
      // if (this.ubicacionBobLlena) { await openToast('Ubicación llena (regla BOB)'); return }
      try {
        const modal = await modalController.create({
          component: InventarioSeleccionProductoModal,
          componentProps: { filtroInicial: '' }
        })
        await modal.present()
        const { data, role } = await modal.onWillDismiss()
        if (role !== 'confirm' || !data || !data.item) return
        
        
        /* Se comenta hasta nuevo aviso
        // Validación Front de Regla BOB antes de llamar (UX rápida)
        if (this.ubi.startsWith('BOB')) {
          const esBobina = data.item.geslot === 'E'
          const esCable = data.item.geslot === 'S'
          
          const ls = this.lineas || []
          // Consideramos activos solo aquellos con cantidad > 0
          const activos = ls.filter(l => Number(l.inputCantidad || 0) > 0)
          const activeBobinas = activos.filter(l => l.geslot === 'E')
          const activeCables = activos.filter(l => l.geslot === 'S')

          // Capacidad
          if (esBobina && activeBobinas.length >= 1) {
            await openAlertaV2('Ubicación llena', 'Solo se permite 1 Bobina activa en esta ubicación. Ponga a 0 la existente si desea sustituirla.')
            return
          }
          if (esCable && activeCables.length >= 1) {
            await openAlertaV2('Ubicación llena', 'Solo se permite 1 Cable activo en esta ubicación. Ponga a 0 el existente si desea sustituirlo.')
            return
          }

          // Coherencia de Lote (Bobina <-> Cable)
          const nuevoLote = data.item.lote || data.item.numlot || 'N'
          
          if (esBobina && activeCables.length > 0) {
             const cableLote = activeCables[0].lote
             if (cableLote !== nuevoLote) {
                await openAlertaV2('Error de Lote', `La bobina debe tener el mismo lote que el cable existente (${cableLote}). Lote actual: ${nuevoLote}`)
                return
             }
          }
          
          if (esCable && activeBobinas.length > 0) {
             const bobinaLote = activeBobinas[0].lote
             if (bobinaLote !== nuevoLote) {
                 await openAlertaV2('Error de Lote', `El cable debe tener el mismo lote que la bobina existente (${bobinaLote}). Lote actual: ${nuevoLote}`)
                 return
             }
          }
        }
        */

        await this.guardarNuevoArticulo(data.item)
        
      } catch (ex) {
        await openAlertaV2('Alta de artículo', 'No se pudo abrir o procesar el selector de artículos')
        console.log(ex)
      }
    },
    async contabilizar () {
      if (!this.pdv || !this.fecinv || !this.ubi) return
      try {
        // conforme a contrato, enviamos { fecinv, lineas[] } y parámetros PDV via meta
        const payload = { 
          fecinv: this.fecinv, 
          clasif: this.clasif,
          lineas: this.lineas.map(l => ({ 
            ubicacion: this.ubi, 
            sku: l.sku, 
            numlot: l.lote || 'N', 
            stoman: l.inputCantidad
          })) 
        }
        const res = await this.$http.post(`/inventario_contabilizar/${this.pdv}`, payload)
        const data = (res && res.data) || {}
        if (Object.keys(data).length === 0 || data.status === 0 || data.error) {
          throw { response: { data: { message: data.message || data.alert || 'Error al contabilizar.' } } }
        }
        openToast('Ubicación contada')
        this.$router.replace({ 
          name: 'inventario_detalle', 
          params: { pdv: this.pdv, fecinv: this.fecinv, clasif: this.clasif },
          query: this.$route.query 
        })
      } catch (ex) {
        const msg = ex.response?.data?.message || ex.response?.data?.alert || 'Error al contar ubicación'
        openToast(msg)
        console.log(ex)
      }
    },
    async reabrir () {
      if (!this.pdv || !this.fecinv || !this.ubi) return
      try {
        const payload = {
          fecinv: this.fecinv,
          clasif: this.clasif,
          ubis: [this.ubi]
        }
        const res = await this.$http.post(`/inventario_reabrir_sel/${this.pdv}`, payload)
        const data = (res && res.data) || {}
        if (Object.keys(data).length === 0 || data.status === 0 || data.error) {
          throw { response: { data: { message: data.message || data.alert || 'Error al reabrir.' } } }
        }
        openToast('Ubicación reabierta')
        // Recargar líneas para actualizar estado y permitir edición
        await this.cargarLineas()
      } catch (ex) {
        const msg = ex.response?.data?.message || ex.response?.data?.alert || 'Error al reabrir ubicación'
        openToast(msg)
        console.log(ex)
      }
    },
    clickBotonDerecho () {
      if (this.modoReabrir) {
        this.reabrir()
      } else {
        this.contabilizar()
      }
    },
    async desbloquearUbicacion () {
      // intentamos liberar el bloqueo de la ubicación (si el backend lo soporta)
      try {
        const response = await this.$http.post(`/inventario_ubicacion/${this.pdv}/${this.fecinv}/${this.clasif}/${this.ubi}`, { blqUsr: null, ubiku_rol: this.ubiku_rol })
        
        // Verificamos que la respuesta sea válida antes de marcar como liberado
        if (response && response.data) {
          // Si es un array, verificamos que tenga elementos o que sea válido
          if (Array.isArray(response.data)) {
            this.liberado = true
          } else if (response.data && typeof response.data === 'object') {
            // Si es un objeto, verificamos que tenga las propiedades esperadas
            if (response.data.status !== 0 || response.data.lineasBloqueadas !== undefined) {
              this.liberado = true
            }
          }
        }
      } catch (ex) {
        // Si es un error de negocio (conflicto, etc.), lo registramos pero no bloqueamos la salida
        if (ex && ex.isBusinessError) {
          console.log('Desbloqueo: error de negocio', ex.response?.data || ex)
        } else {
          // Si es un error técnico inesperado, lo registramos para debugging
          console.log('Desbloqueo: error técnico', ex)
        }
        // En cualquier caso, no bloqueamos la salida del usuario
        this.liberado = true
      }
    },
    async salir () {
      // salir usando navegación estandar del navegador (router back)
      // Delegamos el desbloqueo al guardia beforeRouteLeave para consistencia con el botón de atrás de la cabecera
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        // Fallback solo si no hay historial
        this.$router.replace({ name: 'inventario_detalle', params: { pdv: this.pdv, fecinv: this.fecinv, clasif: this.clasif } })
      }
    },
    inputDeshabilitado (/*ln*/) {
      if (!this.ubicacionEditable) return true
      
      /*
      // Regla BOB: Bloqueo de inputs si ya hay otro activo del mismo tipo
      if (this.ubi && this.ubi.startsWith('BOB')) {
        const miVal = Number(ln.inputCantidad || 0)
        
        // Si tengo valor > 0, estoy habilitado (para poder corregir/poner a 0)
        if (miVal > 0) return false
        
        // Si soy 0, miro si hay otro de mi tipo activo
        const tipo = ln.geslot // 'E' o 'S'
        if (tipo === 'E' || tipo === 'S') {
          const ls = this.lineas || []
          // Buscamos si hay OTRO item del mismo tipo con cantidad > 0
          const otroActivo = ls.some(l => l !== ln && l.geslot === tipo && Number(l.inputCantidad || 0) > 0)
          if (otroActivo) return true
        }
      }
      */

      return false
    }
  },
  // Guardia de ruta para liberar bloqueo al abandonar la página por cualquier navegación
  beforeRouteLeave (to, from, next) {
    try { if (this.sse) { this.sse.close(); this.sse = null } } catch { void 0 }
    if (this.liberado) { next(); return }
    this.liberado = true
    Promise.resolve(this.desbloquearUbicacion()).finally(() => next())
  },
  computed: {
    // control para habilitar/deshabilitar InfiniteScroll
    puedeCargarMas () {
      return this.visibleItems.length < this.filtradas.length
    },
    ubicacionEditable () {
      const ls = this.lineas || []
      if (!ls.length) return true
      return ls.some(l => {
        const est = l.estado || inventario_estados.pendientes.db
        return est === inventario_estados.pendientes.db || est === inventario_estados.reabierto.db
      })
    },
    todosItemsInformados () {
      const ls = this.lineas || []
      // Si no hay líneas, permitimos confirmar
      if (!ls.length) return true
      // Verificamos que todas las líneas tengan un valor válido (no null/undefined). El 0 cuenta como válido.
      return ls.every(l => l.inputCantidad !== null && l.inputCantidad !== undefined)
    },
    // ubicacionBobLlena () {
    //   if (!this.ubi || !this.ubi.startsWith('BOB')) return false
    //   const ls = this.lineas || []
    //   const activos = ls.filter(l => Number(l.inputCantidad || 0) > 0)
    //   const bobinas = activos.filter(l => l.geslot === 'E').length
    //   const cables = activos.filter(l => l.geslot === 'S').length
    //   
    //   // Llena solo si ya tenemos el par completo activo (1 Bobina + 1 Cable)
    //   // En este caso no permitimos añadir más para no violar la regla de unicidad
    //   return bobinas >= 1 && cables >= 1
    // },
    ubicacionAprobada () {
      const ls = this.lineas || []
      if (!ls.length) return false
      return ls.every(l => l.estado === inventario_estados.aprobado.db)
    },
    modoReabrir () {
      return this.ubicacionAprobada
    },
    textoBotonDerecho () {
      return this.modoReabrir ? 'Reabrir' : 'Confirmar'
    },
    colorBotonDerecho () {
      return this.modoReabrir ? 'warning' : 'success'
    },
    validacionBobinasOk () {
      return true
    },
    disabledBotonDerecho () {
      if (this.modoReabrir) return false
      return !this.ubicacionEditable || !this.todosItemsInformados || this.isEditing
    }
  }
})
</script>

<style scoped>
.izquierda { text-align: left; }
.muy-grande { font-size: 1.4rem; }
.stoman-input { max-width: 110px; margin-left: auto; margin-right: 0; }
ion-text.fake-titulo { color: var(--ion-color-primary) !important; }
span.oscuro { color: var(--ion-color-medium) !important; padding-left: 0.3rem !important; }
span.boton-opciones { font-size: larger !important; font-weight: bold !important; }
.titulo { font-size: 1rem; font-weight: bold; margin-top: 10px; margin-bottom: 4px; }
/* estilos reutilizados del estilo Picking para header contador */
.pickings-counter-sticky { position: sticky; top: 0.25rem; z-index: 8; background-color: white; }
.linea-ubi .mini-label { font-size: 0.75rem; color: var(--ion-color-medium); margin-bottom: 4px; }
.linea-ubi .valor { font-size: 0.95rem; margin-top: 4px; }
.linea-ubi .desc { font-size: 0.9rem; color: var(--ion-color-dark); margin-bottom: 4px; }
.dif.success { color: var(--ion-color-success); }
.dif.warning { color: var(--ion-color-warning); }
.dif.darkdanger { color: var(--ion-color-danger); }
.dif.primary { color: var(--ion-color-primary); }
.add-article.borde { border: 2px dashed var(--ion-color-light); border-radius: 10px; }
.pickings-counter-sticky {
  position: sticky;
  top: 0;
  z-index: 15;
  background-color: white;
  padding: 15px 70px;
  margin: 0;
  width: 100%;
}
.valor-texto { font-size: 1.3rem; font-weight: 600; }
.stock-nuevo { font-size: 0.95rem; }
.stoman-input.bordered { border: 1px solid var(--ion-color-dark); border-radius: 10px; padding: 2px 4px; }
.valor-ud { display: block; margin-top: 4px; color: var(--ion-color-medium); }
.secundarias { font-size: 0.8rem; color: var(--ion-color-danger); }
.container-tablet { width: 100%; max-width: 768px; margin: 0 auto; scrollbar-width: none; }
.icon-stack { position: relative; display: inline-block; width: 1.6rem; height: 1.6rem; }
.icon-stack .base-icon { font-size: 1.6rem; }
.icon-stack .overlay-icon { position: absolute; right: -0.5rem; top: -0.15rem; font-size: 0.8rem; color: var(--ion-color-primary); background: #fff; border-radius: 50%; padding: 0.05rem; box-shadow: 0 0 0 1px rgba(0,0,0,0.05); }
.badges-container { display: flex; flex-wrap: wrap; gap: 4px; }
.usuario-contado { color: var(--ion-color-primary); font-size: 0.85rem; margin-top: 4px; }
</style>
